import type { Props as IconProps } from 'src/components/ui/Icon';

const assetIcons: Record<string, IconProps['name']> = {
    ac: 'AirConditioner',
    accessibility: 'Accessibility',
    alarm: 'Alarm',
    balcony: 'Balcony',
    cave: 'Cave',
    dressing: 'Dressing',
    fireplace: 'Fireplace',
    garage: 'Parking',
    garden: 'Garden',
    elevator: 'Elevator',
    policeman: 'Policeman',
    pool: 'Pool',
    spa: 'Spa',
    sport: 'Sport',
    terrace: 'Terrace',
    upstairs: 'Upstairs',
    veranda: 'Veranda',
    view: 'View',
    yard: 'Yard',
};

export default assetIcons;
